import script from "./PublicMemorialPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicMemorialPage.vue?vue&type=script&setup=true&lang=js"

import "./PublicMemorialPage.vue?vue&type=style&index=0&id=49f6ae14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49f6ae14"]])

export default __exports__